/* eslint-disable react-hooks/set-state-in-effect */
/**
 * useGenerationBrandState
 *
 * Manages reactive brand-ID selection driven by template/preset changes.
 * Max 50 lines.
 */
import { useState, useEffect } from 'react';

interface Options {
  hideBrandSelector?: boolean;
  initialTemplateId?: string;
  presetType?: string;
  customPresets?: Array<{ id: string; default_brand_id?: string | null }>;
}

export function useGenerationBrandState({ hideBrandSelector, initialTemplateId, presetType, customPresets }: Options) {
  const [internalBrandId, setInternalBrandId] = useState<string | null>(null);

  // Initial brand load from initialTemplateId
   
  useEffect(() => {
    if (hideBrandSelector || !initialTemplateId || !customPresets) return;
    const template = customPresets.find((p) => p.id === initialTemplateId);
    if (template?.default_brand_id) setInternalBrandId(template.default_brand_id);
  }, [initialTemplateId, customPresets, hideBrandSelector]);

  // Reactive brand load on preset change
   
  useEffect(() => {
    if (hideBrandSelector || !customPresets || presetType === undefined) return;
    if (!presetType.startsWith('custom:')) { setInternalBrandId(null); return; }
    const templateId = presetType.replace('custom:', '');
    const template = customPresets.find((p) => p.id === templateId);
    setInternalBrandId(template?.default_brand_id ?? null);
  }, [presetType, customPresets, hideBrandSelector]);

  return { internalBrandId, setInternalBrandId };
}
